;(function (w) {
		'use strict';
		w.EureCeram = {
			init: () => {
				AOS.init({
					duration: 1200,
				});
				EureCeram.eventListener();
			},

			ThemeHelpers: {
				toggleDrawerMobileMenu: () => {
					document.getElementById('drawer-mobile-menu').classList.toggle('drawer-mobile-menu-active');
				},

				showOverlay: () => {
					document.querySelector('.overlay').classList.add('overlay-active');
				},

				hideOverlay: () => {
					document.querySelector('.overlay').classList.remove('overlay-active');
					EureCeram.ThemeHelpers.hideUserBar();
				},

				showUserBar: () => {
					EureCeram.ThemeHelpers.showOverlay();
					document.querySelector('.user-bar').classList.add('user-bar-active');
				},

				hideUserBar: () => {
					document.querySelector('.user-bar').classList.remove('user-bar-active');
				},

				changeQuantity: (event) => {
					let currency = 'EUR';
					const unitPrice = Number(document.querySelector('.unit-price .new-price span:first-child')?.innerHTML.replace('€', '').replace('.','').replace(',','.')) || null;
					const target = event.target.closest('.quantity-change');
					const changeType = target.getAttribute('data-type');
					const targetInput = target.closest('.quantity-container').querySelector('input');
					let currentValue = parseInt(targetInput.value);
					if(changeType === 'decrease') {
						if(currentValue < 2) {
							currentValue = 1;
						} else {
							currentValue = currentValue - 1;
						}
					} else if(changeType === 'increase') {
						currentValue = currentValue + 1
					}
					targetInput.value = currentValue;
					if(currency === "TL") {
						currency = "TRY";
					}
                  	const formatter = new Intl.NumberFormat('de-DE', {
                		style: 'currency',
                		currency: currency
                	});
                    if(document.querySelector(".new-price.total-price")) {

                      document.querySelector(".new-price.total-price").innerHTML = (formatter.format(unitPrice *parseFloat(quantityInput.value.replace(',', '.'))));
                    }
				}
			},

			eventListener: () => {
				document.querySelector('.mobile-menu').addEventListener('click', (event) => {
					event.stopPropagation();
					EureCeram.ThemeHelpers.toggleDrawerMobileMenu();
					document.body.classList.toggle('overflow-hidden');
					if(document.body.classList.contains('overflow-hidden')) {
						window.scrollTo(0,0);
					}
				});

				document.querySelector('.overlay').addEventListener('click', () => {
					EureCeram.ThemeHelpers.hideOverlay();
				});

				document.querySelectorAll('.header-user.is-not-logged-in').forEach(headerUser => {
					headerUser?.addEventListener('click', () => {
						if(document.querySelector('.user-bar').classList.contains('user-bar-active')) {
							EureCeram.ThemeHelpers.hideUserBar();
							EureCeram.ThemeHelpers.hideOverlay();
							return;
						}
						EureCeram.ThemeHelpers.showUserBar();
					});
				});

				document.querySelectorAll('.navigation-first-level.has-child').forEach(firstLevel => {
					firstLevel.addEventListener('mouseenter', (event) => {
						event.target.classList.add('navigation-active');
						EureCeram.ThemeHelpers.showOverlay();
					});
					firstLevel.addEventListener('mouseleave', (event) => {
						event.target.classList.remove('navigation-active');
						EureCeram.ThemeHelpers.hideOverlay();
					});
				});

				document.querySelectorAll('.quantity-change').forEach(quantityChange => {
					quantityChange.addEventListener('click', (e) => {
						EureCeram.ThemeHelpers.changeQuantity(e)
					})
				})

				document.querySelectorAll('.navigation-first-level.mobile').forEach(firstLevel => {
					firstLevel.addEventListener('click', (event) => {
						if(firstLevel.classList.contains('active')) {
							firstLevel.classList.remove('active');
						} else {
							firstLevel.classList.add('active');
						}
					});
				});
			}
		}
	}(window)
);

document.addEventListener('DOMContentLoaded', () => {
	EureCeram.init();
});
